import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Header } from '../components/layout/Header';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Save } from 'lucide-react';
import { toast } from 'sonner';

export const Settings = () => {
    const { user } = useAuth();
    const [form, setForm] = useState({
        name: user?.name || '',
        email: user?.email || '',
    });

    const handleSave = () => {
        toast.success('Configurações salvas!');
    };

    return (
        <div data-testid="settings-page">
            <Header title="Configurações" subtitle="Gerencie sua conta e preferências" />

            <div className="p-8 max-w-2xl">
                <Card>
                    <CardHeader>
                        <CardTitle className="font-heading">Perfil</CardTitle>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <div className="space-y-2">
                            <Label>Nome</Label>
                            <Input
                                value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })}
                                data-testid="settings-name"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label>Email</Label>
                            <Input
                                type="email"
                                value={form.email}
                                disabled
                                className="bg-slate-50"
                                data-testid="settings-email"
                            />
                        </div>
                        <Button onClick={handleSave} className="w-full" data-testid="settings-save"
                            style={{ background: '#A0462D' }}>
                            <Save className="w-4 h-4 mr-2" />
                            Salvar Alterações
                        </Button>
                    </CardContent>
                </Card>

                <Card className="mt-6">
                    <CardHeader>
                        <CardTitle className="font-heading">Integrações</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
                            <p className="text-sm text-amber-800">
                                <strong>AWS SES:</strong> Configure suas credenciais no backend para habilitar o envio de emails.
                                Variáveis necessárias: <code className="bg-amber-100 px-1 rounded">AWS_ACCESS_KEY_ID</code>, <code className="bg-amber-100 px-1 rounded">AWS_SECRET_ACCESS_KEY</code>, <code className="bg-amber-100 px-1 rounded">AWS_SES_REGION</code> e <code className="bg-amber-100 px-1 rounded">AWS_SES_VERIFIED_EMAIL</code>.
                            </p>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
};

export default Settings;
